(function() {
    'use strict';
    var ProblemsBaseCtrl = function (autoInit) {
        return function (_, $scope, $stateParams, MyChartService, PatientPortalStorageRepository) {
            $scope.name = 'Problems';
            $scope.loading = false;
            $scope.problem = {active: 1, activeName: 'Active'};
            $scope.activeFilters = [
              { Id: 0, Name: 'All' },
              { Id: 1, Name: 'Active' },
              { Id: 2, Name: 'Not Active' }  
            ];

            var activePatientId = PatientPortalStorageRepository.getActivePatient().id;

            $scope.hidden = function hidden(prob) {
                if (prob.Notes) {
                    prob.Show = !prob.Show;
                }
            };

            $scope.update = function update(newFilterId) {
                $scope.problem.active = newFilterId;
                $scope.problem.activeName = _.find($scope.activeFilters, { Id: newFilterId }).Name;
                var activeProblems = _.filter($scope.problems, function (item) {
                    if (Number($scope.problem.active) === 0) {
                        return true;
                    }
                    else if (Number($scope.problem.active) === 1) {
                        return !!item.IsActive;
                    }
                    else if (Number($scope.problem.active) === 2) {
                        return !item.IsActive;
                    }
                });
                $scope.filteredProblems = activeProblems;
                $scope.numprobs = activeProblems.length;
            };

            function initialize() {
                $scope.loading = true;
                $scope.removeHttpError();
                MyChartService
                    .getProblems(activePatientId)
                    .then(function (data) {
                        $scope.problems = _.map(data, function (element) {
                            return _.assignIn(element, {Show: false});
                        });
                        $scope.update($scope.problem.active);
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }
            
            $scope.tileState = {
                isCollapsed: undefined                
            };
            $scope.toggleState = function() {
                if($scope.tileState.isCollapsed === undefined)
                {
                    initialize();
                    $scope.tileState.isCollapsed = false;
                }
                else
                    $scope.tileState.isCollapsed = !$scope.tileState.isCollapsed;
            };

            if(autoInit) {
                initialize();
            }
        };
    };

    var ProblemsCtrl = new ProblemsBaseCtrl(true);
    var ProblemsMobileCtrl = new ProblemsBaseCtrl(false);
    
    angular.module('mychart').controller('ProblemsCtrl',
        ['_', '$scope', '$stateParams', 'MyChartService', 'PatientPortalStorageRepository',
        ProblemsCtrl]);
    angular.module('mychart').controller('ProblemsMobileCtrl',
        ['_', '$scope', '$stateParams', 'MyChartService', 'PatientPortalStorageRepository',
        ProblemsMobileCtrl]);
})();